import React from 'react';
import { Alert } from 'antd';
import {
  SortableContainer,
  SortableElement,
  arrayMove,
} from 'react-sortable-hoc';
import { useEditEmailTypesStore } from '../store';
import EmailTypeRow from './EmailTypeRow';
import AddNewEmailType from './AddNewEmailType';

const SortableList = SortableContainer(({ children }) => {
  return (
    <div className="space-y-2" style={{ marginTop: 10 }}>
      {children}
    </div>
  );
});

const SortableItem = SortableElement(({ children }) => {
  return <>{children}</>;
});

export default function EditEmailTypes() {
  const {
    emailTypes,
    setEmailTypes,
    addNewEmailType,
  } = useEditEmailTypesStore();
  return (
    <div>
      <Alert
        description="Delete saved email types will not be allowed here, use the table to check for remaining of email templates before deleting it. Only creating, updating, sorting is allowed"
        message="Notice"
        showIcon
        type="warning"
      />
      <SortableList
        useDragHandle
        onSortEnd={({ oldIndex, newIndex }) => {
          setEmailTypes(arrayMove(emailTypes, oldIndex, newIndex));
        }}
      >
        {emailTypes.map((item, index) => {
          return (
            <SortableItem index={index} key={item.id}>
              <EmailTypeRow emailType={item} />
            </SortableItem>
          );
        })}
      </SortableList>
      <AddNewEmailType onClick={() => addNewEmailType()} />
    </div>
  );
}
